import { createTheme, Theme, ThemeOptions } from '@mui/material'

export function getAppTheme (darkMode?: boolean): Theme {
  const lightTheme = {
    palette: {
      primary: {
        dark: '#041f44',
        main: '#0D4286',
      },
      secondary: {
        main: '#333333',
        dark: '#151515',
        light: '#9A9A9A',
      },
    },
    typography: {
      fontSize: 12,
    },
    overrides: {
      MuiAutocomplete: {
        option: {
          '&[data-focus="true"]': {
            color: '#0D4286',
          },
        },
      },
      MuiOutlinedInput: {
        root: {
          '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
            border: '2px solid',
            borderColor: '#0D4286',
          },
          '&$focused $notchedOutline': {
            borderColor: '#0D4286',
            borderWidth: 1,
          },
        },
      },
      MuiTabs: {
        root: {
          backgroundColor: '#f5f5f5',
          borderTop: '2px solid',
          borderColor: '#ebe7e9',
        },
      },
      MuiTab: {
        root: {
          '&$selected': {
            backgroundColor: '#ffffff',
            borderTop: '3px solid',
            borderColor: '#0D4286',
            color: '#0D4286',
          },
        },
      },
      MuiButton: {
        root: {
          border: '1px solid #B72841',
          color: '#ffffff',
          backgroundColor: '#0D4286',
          minWidth: '0',
          boxShadow: 'none',
        },
        containedSecondary: {
          backgroundColor: '#ffffff',
          border: '1px solid #FF3939',
          color: '#0D4286',
          '&:hover': {
            backgroundColor: '#ffffff',
            border: '1px solid #FF3939',
            color: '#041F44FF',
          },
        },
        containedPrimary: {
          color: '#ffffff',
          backgroundColor: '#0D4286',
          border: '1px solid #FF3939',
          '&:hover': {
            backgroundColor: '#ffffff',
            color: '1px solid #FF3939',
          },
        },
      },
      MuiPickersToolbarButton: {
        toolbarBtn: {
          border: 'none',
          '&:hover': {
            backgroundColor: 'transparent',
            border: 'none',
          },
        },
      },
      MuiPickersToolbarText: {
        toolbarTxt: {
          '&:hover': {
            color: '#0D4286',
          },
        },
      },
    },
  }

  const darkTheme: ThemeOptions = {
    typography: {
      fontSize: 12,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            border: '1px solid #FF3939',
            minWidth: '0',
            boxShadow: 'none',
          },
          text: {
            color: '#0D4286',
          },
        },
      },
    },
    palette: {
      mode: 'dark',
      primary: {
        main: '#0D4286',
        light: 'rgba(255, 255, 255, 0.5)',
        dark: '#121212',
      },
      grey: {
        A100: 'transparent',
        A200: 'rgba(255, 255, 255, 0.08)',
      },
      secondary: {
        main: '#0D4286',
      },
      background: {
        default: '#121212',
        paper: '#39465c',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.5)',
        secondary: 'rgba(255, 255, 255, 0.3)',
      },
    },
  }

  const theme: Theme = createTheme(darkMode ? darkTheme : lightTheme)

  return theme
}
